var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('a',{staticClass:"event-title",on:{"click":_vm.gohome}},[_vm._v("Events")]),_c('router-view',{staticClass:"mt-3"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }